import { ChangeDetectionStrategy, Component, OnInit, input, output } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BiTranslateDirective, BiTranslatePipe } from "@globals/bi-translate";
import { CustomAnimations } from "@globals/classes/CustomAnimations";
import { ButtonModule } from "primeng/button";
import { InputNumberModule } from "primeng/inputnumber";
import { SliderModule } from "primeng/slider";

@Component({
    selector: "bi-meters-setting",
    imports: [FormsModule, SliderModule, InputNumberModule, ButtonModule, BiTranslatePipe, BiTranslateDirective],
    templateUrl: "./bi-meters-setting.component.html",
    styleUrl: "./bi-meters-setting.component.scss",
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [CustomAnimations.fadeInOut]
})
export class BiMetersSettingComponent implements OnInit {
  defaultMeters = input<number>(1);

  onMetersChanged = output<number>();
  onOkClick = output();

  public meters: number;

  ngOnInit() {
    this.meters = this.defaultMeters();
  }
}
